import { render, staticRenderFns } from "./AppSideMenu.vue?vue&type=template&id=dcfa3dd0&scoped=true&"
import script from "./AppSideMenu.vue?vue&type=script&lang=js&"
export * from "./AppSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppSideMenu.vue?vue&type=style&index=0&id=dcfa3dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa3dd0",
  null
  
)

export default component.exports